export const FETCH_PAYMENT = 'PAYMENTS/PAYMENT/FETCH_PAYMENT'
export const FETCH_PAYMENT_ERROR = 'PAYMENTS/PAYMENT/FETCH_PAYMENT_ERROR'
export const FETCH_PAYMENT_SUCCESS = 'PAYMENTS/PAYMENT/FETCH_PAYMENT_SUCCESS'
